import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import AppButton from "@/components/buttons/AppButton";
import FormField from "@/components/forms/FormField";
import { BUTTONS, LABELS, PLACEHOLDERS } from "@/utils/constants/appConstants/commonConstants";
import { ERROR_CODES } from "@/utils/constants/constants";
import { INVALID_CAPTCHA_TOKEN, INVALID_EMAIL_ADDRESS } from '@/utils/constants/messages';
import { isEmail } from "@/utils/functions/helperFunctions";
import { IS_CAPTCHA_ENABLED } from "@/constants/allconstants";
import { useCaptcha } from "@/utils/hooks/useRecaptcha";
import { ReCaptchaV2 } from "@/utils/hooks/RecaptchaV2";

interface EmailProps {
    handleEmail: any;
}

interface CaptchaData {
    captcha_token: string;
    captcha_type: 'V3' | 'V2';
}

const Email = (props: EmailProps) => {
    const [email, setEmail] = React.useState("");
    const [msg, setMsg] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(false);
    const navigate = useNavigate();
    const { executeCaptcha, setCaptchaV2Token, captchaV3enabled, setCaptchaV3enabled, captchaV2Token } = useCaptcha({ onV2Failure: () => setMsg(INVALID_CAPTCHA_TOKEN) });

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => { setMsg(""); setEmail(e.target.value); };

    const handleSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsLoading(true);
        if (!isEmail(email)) { setIsLoading(false); setMsg(INVALID_EMAIL_ADDRESS); return; }

        const emailVerification = (data: any) => {
            props.handleEmail(data,
                (res: any) => { setIsLoading(false); setEmail(''); },
                (err: any) => {
                    setIsLoading(false);
                    if (err?.response?.data?.error_code !== ERROR_CODES.IP_WHITELISTING_ERROR_CODE) setMsg(err?.response?.data?.message);
                    if (err.response?.data?.error_code === ERROR_CODES.CAPTCHA_V3_INVALID_TOKEN_ERROR_CODE || err.response?.data?.error_code === ERROR_CODES.CAPTCHA_NO_TOKEN_ERROR_CODE) setCaptchaV3enabled(false);
                }
            );
        };

        if (IS_CAPTCHA_ENABLED) {
            try { await executeCaptcha('admin_login_action', (captchaData: CaptchaData) => emailVerification({ email_address: email, ...captchaData })); }
            catch (err: any) { setIsLoading(false); setMsg(INVALID_CAPTCHA_TOKEN); }
        } else {
            emailVerification({ email_address: email });
        }
    }, [email, setIsLoading]);

    return (
        <form method="POST" id="signInForm" onSubmit={handleSubmit} autoComplete="off">
            <div className="mb-4">
                <label className="text-sm font-medium text-foreground mb-1 block" htmlFor="login-form-email-address-input" id="login-form-email-address-label">{LABELS.EMAIL}</label>
                <FormField value={email} onChange={handleEmailChange} type="email" id="login-form-email-address-input" placeholder={PLACEHOLDERS.EMAIL} required />
            </div>
            {msg && <p className="text-destructive text-sm mb-3">{msg}</p>}
            <div>
                <AppButton id="sign-in-btn" disabled={!captchaV3enabled && !captchaV2Token} isLoading={isLoading} btnText={BUTTONS.NEXT} className="btn-lg btn-block btn-primary" type="submit" />
            </div>
            <div className='mt-2'>{!captchaV3enabled ? <ReCaptchaV2 setToken={setCaptchaV2Token} /> : null}</div>
        </form>
    );
};

export default Email;
